import { useEffect, useState } from "react";

export default function useArchitecture(): string | null {
	const [architecture, setArchitecture] = useState<string | null>(null);

	useEffect(() => {
		try {
			// @ts-ignore userAgentData is not supported on all browsers yet
			navigator?.userAgentData.getHighEntropyValues(["architecture"]).then(data => {
				setArchitecture(data.architecture);
			});
		} catch {
			setArchitecture("unkown");
		}
	}, []);

	return architecture;
}
